export interface Whitelabel {
	id: string;
	name: string;
	slug: string;
}

export const SANUS_WHITELABEL_SLUG = 'SANUS';

function toTitleCase(value: string): string {
	return value
		.toLocaleLowerCase('pt-BR')
		.split(/\s+/)
		.filter(Boolean)
		.map((part) => part.charAt(0).toLocaleUpperCase('pt-BR') + part.slice(1))
		.join(' ');
}

export function formatWhitelabelLabel(
	whitelabel?: Pick<Whitelabel, 'name' | 'slug'> | null,
): string {
	if (!whitelabel) {
		return '';
	}

	return toTitleCase(
		whitelabel.name?.trim() || whitelabel.slug.replace(/_/g, ' '),
	);
}

export function isNonSanusWhitelabel(
	whitelabel?: Pick<Whitelabel, 'slug'> | null,
): boolean {
	return !!whitelabel?.slug && whitelabel.slug !== SANUS_WHITELABEL_SLUG;
}
